<template>
    <b-container>
        <b-row>
            <b-col cols="6" lg="3">
                <DateInput v-model="fromDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <DateInput v-model="toDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <b-form-select v-model="selectedCategoryId" :options="categoryOptions"></b-form-select>
            </b-col>
            <b-col cols="6" lg="3">
                <b-button-group block class="w-100">
                    <b-button @click="getData">{{$t('admin_report.show_report')}}</b-button>
                    <b-button variant="light" @click="exportData"><font-awesome-icon icon="file-export"></font-awesome-icon></b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <BarChart :chart-data="chartData" height="200px"></BarChart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import BarChart from "./BarChart";
    import DateInput from "../DateInput";
    import _ from 'lodash';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faFileExport} from '@fortawesome/free-solid-svg-icons'

    library.add(faFileExport);

    export default {
        name: 'EventHourReport',
        components: {DateInput, BarChart},
        data() {
            return {
                fromDate: DateTime.local().startOf('year').toISO(),
                toDate: DateTime.local().endOf('year').toISO(),
                selectedCategoryId: null,
                categories: [],
                rawData: [],
            }
        },
        computed: {
            categoryOptions() {
                return _.concat(
                    [{value: null, text: this.$t('all')}],
                    this.categories.map(function (c) {
                        return {value: c.id, text: c.name};
                    }));
            },
            chartData() {
                let labels = this.rawData.map(function (d) {
                    return d.label;
                });

                let data = this.rawData.map(function (d) {
                    return d.value;
                });

                return {
                    labels: labels,
                    datasets: [{
                        label: this.$t('admin_report.event_total_hour'),
                        data: data,
                    }],
                }
            },
        },
        mounted() {
            this.getCategories();
        },
        methods: {
            getCategories() {
                this.$callAPI('hkiarace/event_category/', {}, function (response) {
                    this.categories = response.body.categories;
                })
            },
            getData() {
                this.$callAPI('hkiarace/admin/report/', {
                    report_type: 'CATEGORY_TOTAL_HOUR',
                    params: {
                        from: DateTime.fromISO(this.fromDate).toSeconds(),
                        to: DateTime.fromISO(this.toDate).toSeconds(),
                        category_id: this.selectedCategoryId,
                    },
                }, function (response) {
                    this.rawData = response.body.datasets;
                })
            },
            exportData() {
                this.$downloadFile('hkiarace/admin/report/export/', {
                    report_type: 'CATEGORY_TOTAL_HOUR',
                    params: {
                        from: DateTime.fromISO(this.fromDate).toSeconds(),
                        to: DateTime.fromISO(this.toDate).toSeconds(),
                        category_id: this.selectedCategoryId,
                    },
                }, 'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            },
        },
    }
</script>

<style>

</style>
